var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cards-tags',{attrs:{"no-bottom-border":"","title":"Наши программы","tagSelectAllName":"Все программы","tagSelected":"Популярное","tags":"","tagAllEnd":"","factoidsDouble":"","tags-limit":"0","content":_vm.itemsContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }